import {createNamespacedHelpers} from 'vuex'
import {namespace} from '../../vuexstore'
import {default as cardStore, namespace as cardNamespace} from '../../vuexstore/modules/giftcard'
const {mapGetters, mapActions} = createNamespacedHelpers([namespace, cardNamespace].join('/'))

/**
 *
 * @param options{storePath: '', get: '', set: '', prefix: '', suffix: ''}
 * @returns {*}
 */
export const mapState = (options) => {
  const {storePath, prefix = '', suffix = ''} = options
  const states =  _.reduce(storePath, (fns, item, key) => {
    fns[prefix + key + suffix] = {
      get() {
        return this.giftCardInput(key)
      },
      set(value) {
        this.setGiftCardInput({[key]: value})
      }
    }
    return fns
  }, {})
  return states
}

export default {
  created() {

  },
  methods: {
    ...mapActions(Object.keys(cardStore.actions)),

    canShowBalance(giftcard) {
      return !(giftcard.role === 'giver' && giftcard.state !== 'given')
    },

    canShowNumber(giftcard) {
      return giftcard.state !== 'given'
    },

    canShowRecipient(giftcard) {
      return giftcard.role === 'giver' && giftcard.recipient
    },

    canShowGiver(giftcard) {
      return giftcard.role === 'recipient' && giftcard.giver && giftcard.giver.data.id !== this.authUser.id
    },

    isForMyself(giftcard) {
      return giftcard.role === 'recipient' && giftcard.giver && giftcard.giver.data.id === this.authUser.id
    },

    isClaimable(giftcard) {
      return giftcard.role === 'recipient' && giftcard.state === 'given'
    },

    isClaimableForMyself(giftcard) {
      return giftcard.role === 'giver' && giftcard.state === 'given'
    },

    isCodeRecoverable(giftcard) {
      return giftcard.role === 'recipient' && giftcard.state !== 'given'
    },

    isResendable(giftcard) {
      return giftcard.state === 'given' && giftcard.role === 'giver'
    },

    isArchivable(giftcard) {
      return giftcard.state !== 'given'
    },
  },
  computed: {
    ...mapGetters(Object.keys(cardStore.getters)),
    ...mapState({storePath: cardStore.state.form}),
  }
}

